import React from "react";

interface HistoryDetailPageProps {
  // Add props here
}

const HistoryDetailPage: React.FC<HistoryDetailPageProps> = () => {
  return (
    <div>
      <h1>Hello from HistoryDetailPage</h1>
    </div>
  );
};

export default HistoryDetailPage;